import Typography from '@mui/material/Typography';

/**
 * Silver plan SMS unit hint (same style as Announcement bulk SMS).
 */
export default function SmsUnitEstimateHint({ estimate, label = 'recipients', sx = {} }) {
    if (!estimate || !estimate.wallet?.packageB) return null;
    const need = estimate.unitsRequired || 0;
    const count = estimate.recipientCount || 0;
    const balance = estimate.wallet.balance || 0;
    return (
        <Typography variant="body2" sx={{ mt: 1, color: '#0369a1', textAlign: 'left', px: 1, ...sx }}>
            This send needs <strong>{need}</strong> SMS units ({count} {label}). Balance:{' '}
            <strong>{balance}</strong> units.
            {need > balance ? ' Purchase units on Pricing before sending.' : ''}
        </Typography>
    );
}
